import cx from 'classnames';

import {
  Icon,
  V2,
  useTranslation,
  ToolTip,
  SecondaryButton,
  ARIA_LABELS,
} from '@testsigma/atoms';
import classNames from 'classnames';

const { BUTTON_SIZE, BUTTON_VARIANTS, Button } = V2;

export const ReportAgentButton = ({
  onClick,
  className = '',
  iconClassName = '',
  showLabel = false,
  showTooltip = true,
  iconOnly = false,
  isV2 = false,
}) => {
  const { t } = useTranslation();
  const renderIcon = (includeOnClick = true) => (
    <Icon
      name='emergency-home'
      onClick={includeOnClick ? onClick : undefined}
      className={cx('text-base text-secondary-unique-800', iconClassName)}
    />
  );
  const renderContent = () => {
    if (iconOnly) {
      return (
        <button
          type='button'
          onClick={onClick}
          aria-label={t('agent.report_agent')}
          className={cx('inline-flex items-center justify-center', className)}
        >
          {renderIcon(false)}
        </button>
      );
    }
    return isV2 ? (
      <Button
        variant={BUTTON_VARIANTS.SECONDARY}
        size={BUTTON_SIZE.SMALLEST}
        className={cx('text-secondary-unique-600', className)}
        onClick={onClick}
        aria-label={t('agent.report_agent')}
      >
        {renderIcon()}
        {showLabel && <span>{t('agent.report_agent')}</span>}
      </Button>
    ) : (
      <SecondaryButton
        className={cx('text-secondary-unique-600', className)}
        onClick={onClick}
        aria-label={showLabel ? undefined : ARIA_LABELS.REPORT_AGENT}
      >
        {' '}
        {renderIcon()}
        {showLabel && <span>{t('agent.report_agent')}</span>}
      </SecondaryButton>
    );
  };

  if (!showTooltip) return renderContent();

  return (
    <ToolTip
      content={t('agent.report_agent')}
      className={classNames({ 'h-7': isV2 })}
    >
      {renderContent()}
    </ToolTip>
  );
};
